import { Button } from "ui/components/button";
import React from "react";
import { useNavigate } from "react-router-dom";

const EditItemButton = ({ href = "edit", disabled = false, ...props }) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(href);
  };

  return (
    <Button
      {...props}
      disabled={disabled}
      variant="black"
      onClick={handleEdit}
      className="flex gap-2 cursor-pointer w-full"
    >
      Edit
    </Button>
  );
};

export default EditItemButton;
